<template>
	<div class="aup-box-select w-100">
		<div class="row m-0">
			<div class="col-12" v-for="(item, index) in items" :key="'radio-option-' + index">
				<input
					type="radio"
					:id="'radio-' + name + index"
					:name="name"
					:value="item"
					:checked="item === local_value"
					class="d-none"
					@change="toggleItem(item)"
				/>
				<label
					:for="'radio-' + name + index"
					class="w-100 my-1 d-flex align-items-center label-option"
				>
					<span class="radio-indicator" :class="{ active: item === local_value }"></span>
					<span class="label-text">error:call:53</span>
				</label>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "BaseRadioGroup",
	props: {
		items: {
			type: Array,
			required: true
		},
		value: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: 'radio-group'
		}
	},
	data() {
		return {
			local_value: this.value
		};
	},
	watch: {
		value(val) {
			this.local_value = val;
		},
		local_value(val) {
			this.$emit('input', val);
		}
	},
	methods: {
		toggleItem(item) {
			if (this.local_value !== item) {
				this.local_value = item;
			}
		}
	}
};
</script>

<style scoped>
.label-option {
	cursor: pointer;
	gap: 0.5rem;
}

.radio-indicator {
	width: 16px;
	height: 16px;
	border: 2px solid #e75300;
	border-radius: 50%;
	display: inline-block;
	position: relative;
	transition: all 0.2s ease;
}

.radio-indicator.active::after {
	content: '';
	position: absolute;
	top: 3px;
	left: 3px;
	width: 6px;
	height: 6px;
	background-color: #e75300;
	border-radius: 50%;
}
</style>
